import { analyticsLogEvent } from '@src/utils/analytics';

export const footerNavAnalyticEvents = {
  eventClickFooterNavTop: () => analyticsLogEvent({ category: '【click】固定メニュー_TOP', action: 'TOP' }),
  eventClickFooterNavHistory: () => analyticsLogEvent({ category: '【click】固定メニュー_履歴', action: '履歴' }),
  eventClickFooterNavAA: () => analyticsLogEvent({ category: '【click】固定メニュー_連携追加', action: '連携追加' }),
  eventClickFooterNavReport: () => analyticsLogEvent({ category: '【click】固定メニュー_資産・収支', action: '資産・収支' }),
  eventClickMenuList: () => analyticsLogEvent({ category: '【click】固定メニュー_メニュー', action: 'メニュー' })
};
